export const getIntialValues = (data = {}) => ({
  meta_seo: {
    meta_title: data?.meta_seo?.meta_title || "",
    meta_keyword: data?.meta_seo?.meta_keyword || "",
    meta_desc: data?.meta_seo?.meta_desc || "",
    meta_slug_url: data?.meta_seo?.meta_slug_url || "",
  },
  hero_banner: {
    heading: {
      white: data?.hero_banner?.heading?.white || "",
      orange: data?.hero_banner?.heading?.orange || "",
    },
    subHeading: data?.hero_banner?.subHeading || "",
    paragraphs: data?.hero_banner?.paragraphs || [""],
    image: data?.hero_banner?.image || "",
  },
  about_section: {
    heading: {
      white: data?.about_section?.heading?.white || "",
      orange: data?.about_section?.heading?.orange || "",
    },
    desc: data?.about_section?.desc || "",
    sub_desc: data?.about_section?.sub_desc || "",
    image: data?.about_section?.image || "",
  },
  practicality_section: {
    heading: data?.practicality_section?.heading || "",
    heading_orange: data?.practicality_section?.heading_orange || "",
    drivers: data?.practicality_section?.drivers?.length
      ? data.practicality_section.drivers
      : [{ icon: "", text: "" }],
  },
  investment_section: {
    heading: data?.investment_section?.heading || "",
    heading_orange: data?.investment_section?.heading_orange || "",
    description: data?.investment_section?.description || "",
    drivers: data?.investment_section?.drivers?.length
      ? data.investment_section.drivers.map(({ icon, ...rest }) => rest)
      : [{ text: "" }],
    bottom_para_1: data?.investment_section?.bottom_para_1 || "",
  },
  contact_section: {
    title: data?.contact_section?.title || "",
    description: data?.contact_section?.description || "",
  },
  map: {
    title: data?.map?.title || "",
    highlight: data?.map?.highlight || "",
    sub_title: data?.map?.sub_title || "",
    url: data?.map?.url || "",
  },
  footer_bgimg: data?.footer_bgimg || "",
});

export const generatePayload = (values) => {
  const { _id, createdAt, updatedAt, __v, ...payload } = values;
  return payload;
};
